<template>
	<div class="register-view">
        <div class="big-logo">
            <img class="big-logo-image" src="@/assets/checklist-app.jpeg" alt="chillServices_logo">
            <h3 class="big-logo-text">Checklist</h3>
        </div>
        <section>
            <infoBox />
        </section>
		<div class="formcontainer">
            <h3 class="login-header">Request Delete account</h3>
            <div class="form-container-box">
                <div class="login-fields">
                    <form>
                        <div class="field">
                             <label for="loginEmail">{{trans('email')}}</label>
                            <input type="email" v-model="email" id="loginEmail" class="field-text email" placeholder="email" autocomplete="on" />
                        </div>
                    </form>
                </div>
                <div class="button-box">
                    <button v-if="!authLoading" class="button-primary" @click="vue_request_delete(email)">{{trans('Anfrage senden')}}</button>
                    <button v-else-if="authLoading" class="button-box-element" ><loadingDots /></button>
                </div>
                <div class="button-box">
                    <button class="button-secondary" @click="gotoLogin()">{{trans('back')}}</button>
                </div>
            </div>
		</div>
        <section class="footer">
            <div class="footer-inner">
                <span class="footer-text fat">CheckList ist ein Produkt der Fa. ChillServices.</span>
                <span class="footer-text">Für weitere Informationen besuchen Sie bitte unsere website</span>
                <span class="footer-text">© Alle Rechte vorbehalten, 2022.</span>
            </div>
        </section>
    </div>
</template>

<script>
	export default {
		name: 'register',
		data() {
			return {
				email: "",
				password: "",
				accepted: false,
                authLoading: false
			}
		},
		computed: { },
        watch: {
            '$route' () {
                this.authLoading = false
            }
        },
		methods: {
			vue_request_delete(email) { 
                this.authLoading = true
				this.request_delete(email)
                this.$router.push({ path: `/login` });
			},
            gotoLogin(){
                this.$router.push({ path: `/login` });
            }
		},
		mounted(){

		}
	}
</script>

<style scoped>
    .register-view {
        margin-top: 60px;
    }
       .big-logo {
        display: flex;
        flex-direction: column;
        width: 86vw;
        margin: 0px auto;
        
    }
    .big-logo-image, .big-logo-text {
        margin: 0px auto;
        width: 100px;
        height: auto;
        text-align: center;
    }
    .formcontainer {
        border-left: solid #1B608C 5px;
        width: 90vw;
        max-width: 900px;
        margin: 20px auto 100px auto;
        background-color: #FFF;
        padding: 24px 12px;
        box-sizing: border-box;
    }
    .field {
        display: flex;
        flex-direction: column;
        margin-bottom: 12px;
    }
    /* .form-container-box {  } */
    h3 {
        font-weight: normal;
        font-size: 16px;
        margin-top: 0px;
    }
    .field-text {
        border: none;
        border-bottom: solid transparent 2px;
        height: 28px;
    }
    .field-text:focus {
        outline: none;
        border: none;
        border-bottom: solid #51D07D 2px;
    }
    .button-box {
        text-align: center;
    }
    .button-primary {
        width: 100%;
        background-color: #1B608C;
        color: #FFF;
        height: 28px;
        border-radius: 28px;
        border: none;
        margin-top: 8px;
    }
    .button-secondary {
        width: 100%;
        background-color: #ECEDF0;
        color: #000;
        height: 28px;
        border-radius: 28px;
        border: none;
        margin-top: 8px;
    }
    .policy {
        text-align: center;
    }
    .a-tag {
        text-decoration: none;
        color: #1B608C;
        display: inline-block;
    }
    label {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-weight: 400;
    }
    .footer {
        position: fixed;
        left: 0px;
        right: 0px;
        bottom: 0px;
        height: 70px;
        background-color: #F8F8FA;
    }
    .footer-inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 86vw;
        margin: 0px auto;
        /* border-top: solid #CBCCD5 1px; */
    }
    .footer-text {
        display: block;
        font-size: 12px;
    }
    .fat {
        font-size: 14px;
        font-weight: 500;
    }
      
</style>